import { AnaliseGrauExposicaoRisco } from '@/types/analise/AnaliseGrauExposicaoRisco';
import { GRAU_EXPOSICAO_RISCO_NOMES } from '@/constants/grau-exposicao-risco/GrauExposicaoRisco';
import { BaseComponentProps } from '@/components/BaseComponentProps';
import { ChevronDown, ChevronsDown, ChevronsUp, ChevronUp, Equal } from 'lucide-react';
import { cva } from 'class-variance-authority';
import { AgnesBadge, cn } from '@agnes/ui';
import React from 'react';
import { BadgeEmAnalise } from '@/components/analise/BadgeEmAnalise';

export interface BadgeGrauExposicaoRiscoProps extends BaseComponentProps {
  grau: AnaliseGrauExposicaoRisco | 'EM_ANALISE' | null;
  size?: 'sm' | 'md' | 'lg';
}

const badgeCVA = cva('whitespace-nowrap', {
  variants: {
    grau: {
      CRITICO: 'text-agnes-ger-critico bg-agnes-ger-critico/10',
      ELEVADO: 'text-agnes-ger-elevado bg-agnes-ger-elevado/10',
      MODERADO: 'text-agnes-ger-moderado bg-agnes-ger-moderado/10',
      BAIXO: 'text-agnes-ger-baixo bg-agnes-ger-baixo/10',
      INEXPRESSIVO: 'text-agnes-ger-inexpressivo bg-agnes-ger-inexpressivo/10',
    },
  },
});

const iconCVA = cva('flex items-center justify-start gap-1 justify-self-start', {
  variants: {
    size: {
      sm: 'w-3 h-3',
      md: 'w-4 h-4',
      lg: 'w-6 h-6',
    },
  },
});

const iconMap: Partial<
  Record<AnaliseGrauExposicaoRisco, React.ComponentType<{ className?: string }>>
> = {
  CRITICO: ChevronsUp,
  ELEVADO: ChevronUp,
  MODERADO: Equal,
  BAIXO: ChevronDown,
  INEXPRESSIVO: ChevronsDown,
};

export function BadgeGrauExposicaoRisco({
  className,
  grau,
  size = 'md',
  dataQa,
  ...props
}: BadgeGrauExposicaoRiscoProps) {
  if (!grau || grau === 'EM_ANALISE') {
    return <BadgeEmAnalise dataQa={dataQa} size={size} {...props} />;
  }

  const Icon = iconMap[grau]!;
  return (
    <AgnesBadge
      className={cn(badgeCVA({ grau }), className)}
      size={size}
      dataQa={dataQa}
      {...props}
    >
      <Icon className={cn(iconCVA({ size }))} />
      {GRAU_EXPOSICAO_RISCO_NOMES[grau]}
    </AgnesBadge>
  );
}
